module.exports = __webpack_public_path__ + "static/media/arrow-down-product.3950424f.png";